module.exports = __webpack_public_path__ + "img/play_4.359621bf.png";